import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  SimpleChange,
  ViewChild,
} from '@angular/core';

import intlTelInput from 'intl-tel-input';

import { InputComponent } from '../input/input.component';
import { RtInput } from './../../utils/rt-input';

@Component({
  selector: 'rt-phone-input',
  templateUrl: './phone-input.component.html',
  styleUrls: ['./phone-input.component.less'],
})
export class RtPhoneInputComponent extends RtInput<string> implements OnInit {
  @Input() public countryCode: string;
  @Input() public placeholder: string;

  @Output() public valueChange: EventEmitter<string> = new EventEmitter();

  @ViewChild('inputComponent', { static: true }) public inputComponent: InputComponent;

  public intl: any;

  public ngOnChanges({ countryCode }: { countryCode: SimpleChange }): void {
    if (this.intl && countryCode) this.intl.setCountry(countryCode.currentValue);
  }

  public ngOnInit(): void {
    this.intl = intlTelInput(this.inputComponent.input.nativeElement, {
      initialCountry: this.countryCode || 'gb',
      nationalMode: false,
      preferredCountries: ['nl', 'gb', 'de', 'us'],
      autoPlaceholder: undefined,
      autoHideDialCode: false,
      utilsScript: 'assets/scripts/utils.js',
    });
  }
}
